"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissouriRules = exports.MO_THRESHOLDS = void 0;
const browser_1 = require("encamp-prisma/generated/browser");
const types_1 = require("../types");
const _FEDERAL_1 = require("./_FEDERAL");
const _stateRules_1 = require("./_stateRules");
/**
 * Missouri (MDNR) accumulation limits, 10 CSR 25-5.262 — "Standards
 * Applicable to Generators of Hazardous Waste," which incorporates 40 CFR
 * part 262 by reference and then adds standards of its own.
 *
 * Missouri does not have custom state generator status tiers. Its
 * incorporation reaches parts 273, 279 and 266 subpart P with no state-added
 * universal waste category, so the federal rule decides which program governs
 * a container (40 CFR 273.9, 261.6(a)(4), 266.501).
 *
 * KNOWN GAPS: 10 CSR 25-5.262(2)(A)4 lets each SAA choose the federal limit or
 * Missouri's per-stream one; both are applied (over-strict). The 3-day move
 * window after Missouri's 365 days is not modeled.
 */
/**
 * Missouri's standing satellite limit, which federal 262.15 has no counterpart
 * for; every other threshold is federal.
 */
exports.MO_THRESHOLDS = {
    standingSatelliteYear: {
        id: "standingSatelliteYear",
        scope: "CONTAINER",
        kind: "DAYS_SINCE",
        name: "Satellite accumulation deadline",
        source: { jurisdiction: "MO", citation: "10 CSR 25-5.262(2)(A)4" },
        consequences: [{ kind: "COMPLIANCE_NOT_RECORDED", actionToComply: "MOVE_TO_CENTRAL" }],
        from: "ACCUMULATION_START",
        value: 365,
        warnDays: types_1.APPROACHING_WINDOW_DAYS,
    },
};
/** Missouri (MDNR) accumulation limits, 10 CSR 25-5.262. */
class MissouriRules extends _stateRules_1.StateRules {
    constructor() {
        super(...arguments);
        this.stateStatusDomain = [];
        this.adoptsEpisodicEvents = true;
    }
    facilityThresholds(facility) {
        return _FEDERAL_1.Federal.onSiteThresholds(facility);
    }
    areaThresholds(situation) {
        return _FEDERAL_1.Federal.areaThresholds(situation);
    }
    accumulationCategory(container) {
        // STATE_REGULATED is non-acute pending the waste team's per-state decision.
        return container.classification === browser_1.WasteClassification.STATE_REGULATED
            ? { value: "NON_ACUTE" }
            : _FEDERAL_1.Federal.category(container);
    }
    governingProgram(container) {
        return _FEDERAL_1.Federal.governingProgram(container);
    }
    /**
     * The one-year leg of Missouri's (2)(A)4 alternative to 40 CFR 262.15, which
     * covers only ordinary waste at SQGs and LQGs. An unknown status takes it
     * too, the stricter default. A VSQG stays on federal 262.15, which imposes no
     * standing clock.
     */
    standingSatelliteYear(situation, program) {
        const status = situation.facility.federalGeneratorStatus;
        if (status === "VSQG") {
            return [];
        }
        const basis = status === undefined ? {} : { facility: { federalGeneratorStatus: status } };
        if (program.missing !== undefined) {
            return [
                {
                    ...exports.MO_THRESHOLDS.standingSatelliteYear,
                    determination: "UNDETERMINED",
                    missing: program.missing,
                    basis,
                },
            ];
        }
        return [{ ...exports.MO_THRESHOLDS.standingSatelliteYear, determination: "KNOWN", basis }];
    }
    containerThresholds(situation) {
        const program = _FEDERAL_1.Federal.governingProgram(situation.container);
        const episodic = _FEDERAL_1.Federal.episodicWindow(situation.container, program);
        if (program.value !== undefined && _FEDERAL_1.Federal.isSubclassification(program.value)) {
            return [_FEDERAL_1.Federal.subclassificationTimeLimits[program.value], ...episodic];
        }
        switch (situation.area.type) {
            case "CENTRAL":
                return [
                    program.missing === undefined
                        ? _FEDERAL_1.Federal.centralTimeLimit(situation)
                        : _FEDERAL_1.Federal.undeterminedCentralTimeLimit(program.missing),
                    ...episodic,
                ];
            case "SATELLITE": {
                const caps = _FEDERAL_1.Federal.satelliteCaps(situation);
                return [
                    ...this.standingSatelliteYear(situation, program),
                    ..._FEDERAL_1.Federal.satelliteMoveWindow(this, _FEDERAL_1.FEDERAL_THRESHOLDS.satelliteToCentralMoveWindow, caps, situation.container),
                    ...episodic,
                ];
            }
            case undefined:
                return [
                    _FEDERAL_1.Federal.undeterminedCentralTimeLimit([...(program.missing ?? []), "area.type"]),
                    ...episodic,
                ];
        }
    }
}
exports.MissouriRules = MissouriRules;
//# sourceMappingURL=MO.js.map